import angular from 'angular'
import invoiceTitle from './invoiceTitle'
import invoiceBuyer from './invoiceBuyer'
import creditCode from './creditCode'

const components = angular.module('app.invoiceComponents', [])
components.directive('invoiceTitle', invoiceTitle)
components.directive('creditCode', creditCode)
components.component('invoiceBuyer', invoiceBuyer)
export default components.name



// WEBPACK FOOTER //
// ./src/components/invoiceRelated/index.js